import { C as CosmosIconChevronDown$1, d as defineCustomElement$1 } from './p-DM62vhwv.js';

const CosmosIconChevronDown = CosmosIconChevronDown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChevronDown, defineCustomElement };
